import { useAuthContext } from 'src/auth/hooks';

import { Box, Stack, Avatar, Tooltip, IconButton, Typography } from '@mui/material';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function NavUpgrade() {
  const { user } = useAuthContext();

  // Svuota la cache del browser e ricarica, per avere subito l'ultima versione dell'app.
  const refreshApp = async () => {
    try {
      if ('caches' in window) {
        const names = await caches.keys();
        await Promise.all(names.map((n) => caches.delete(n)));
      }
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
    } catch (e) {
      console.error('Errore pulizia cache:', e);
    }
    window.location.reload();
  };

  const version = import.meta.env.VITE_APP_VERSION || '0.8.0';

  return (
    <Box sx={{ px: 2, pt: 2, pb: 3 }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ p: 1.5, borderRadius: 1.5, bgcolor: 'background.neutral' }}
      >
        <Avatar
          src={user?.photoURL}
          alt={user?.displayName}
          sx={{ width: 40, height: 40, flexShrink: 0 }}
        >
          {user?.displayName?.charAt(0).toUpperCase()}
        </Avatar>

        <Box sx={{ minWidth: 0, flexGrow: 1 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.displayName}
          </Typography>
          <Tooltip title={user?.email || ''} placement="top">
            <Typography variant="caption" component="div" noWrap sx={{ color: 'text.secondary' }}>
              {user?.email}
            </Typography>
          </Tooltip>
        </Box>
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1, px: 1.5 }}>
        <Typography variant="caption" sx={{ color: 'text.disabled' }}>
          Versione {version}
        </Typography>
        <Tooltip title="Aggiorna all'ultima versione" placement="top">
          <IconButton
            size="small"
            aria-label="Aggiorna all'ultima versione"
            onClick={refreshApp}
            sx={{ color: 'text.disabled', '&:hover': { color: 'primary.main' } }}
          >
            <Iconify icon="solar:refresh-bold" width={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
}
